export default __webpack_public_path__ + "static/media/resume-icon.e98d1dc4.jpg";